import React from "react";
import clsx from "clsx";

import { ILesson } from "../../state";
import { renderIconByIndex } from "../../libs/Util";
import Button from "../../atoms/Button";

import styles from "./LessonBrief.module.scss";

export type Props = {
  lesson: ILesson;
  handleOpenGuideline: () => void;
  handleOpenMaterial: () => void;
};

const LessonBrief: React.FC<Props> = ({
  lesson,
  handleOpenGuideline,
  handleOpenMaterial,
}) => {
  return (
    <div className={styles.wrapper}>
      {typeof lesson.skill_no === "number" && (
        <div className={styles.skillNo}>
          {renderIconByIndex(lesson.skill_no)}
        </div>
      )}
      <div className={styles.lessonName}>{lesson.name}</div>
      <div className={styles.lessonTitleArea}>
        <p className={styles.lessonTitle}> {lesson.title}</p>
        {!lesson.published && !lesson.teacher_only && (
          <p className={styles.message}>【生徒に未開放です】</p>
        )}
      </div>
      <div className={styles.btnsArea}>
        <Button
          className={clsx(styles.materialButton, styles.guidance)}
          name="指導書"
          variant="normal"
          onClick={() => handleOpenGuideline()}
        />
        <Button
          className={clsx(
            styles.materialButton,
            styles.projection,
            lesson.teacher_only && styles.invisible,
          )}
          name="投影画面"
          variant="outline"
          onClick={() => handleOpenMaterial()}
        />
      </div>
    </div>
  );
};

export default LessonBrief;
